import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AttributeToggle from 'common/attribute-toggle/AttributeToggle';

export default class ResetTwofa extends Component {
  static propTypes = {
    noButton: PropTypes.bool,
  }

  static defaultProps = {
    noButton: true,
  }

  render() {
    const { props } = this;

    return (
      <AttributeToggle
        recordAttribute='has_twofa'
        requestAttribute='reset_twofa'
        labelText='Has twofa'
        enableText=''
        disableText='Reset twofa'
        disableValue={true}
        noButton={ props.noButton }
        editOnTurnedOff={ false }
        record={ props.record }
        resource={ props.resource }
        translate={ props.translate }
      />
    );
  }
}
